const swiper = new Swiper(".navSwiper", {
    slidesPerView: 'auto',
    spaceBetween: 0,
    navigation: {
        nextEl: ".main__block-nav__tabs-wrapper__arrow-right",
        prevEl: ".main__block-nav__tabs-wrapper__arrow-left",
    },
});